import $ from 'jquery';
import Select from 'blocks/select/select';
import Overlay from 'blocks/overlay/overlay';
import Info from 'portlets/site/roaming/info/info';
import Price from 'portlets/site/roaming/price/price';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaRoaming',
			dom: {
				overlay: '#yotaOverlayRoaming',
				select: '.js-roaming-select',
				content: '.js-roaming-content'
			},
			classes: {
				state: {
					select: 'b-roaming_state_select',
					scroll: 'b-roaming_state_scroll'
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$window = $(window);
		this.preventChange = false;
		this.current = false;
		return this;
	}

	getDom() {
		this.$selects = $(this.options.dom.select);
		this.$overlay = $(this.options.dom.overlay);
		this.$content = this.$el.find(this.options.dom.content);
	}

	prepareOptions(data) {
		const self = this;
		const options = [];
		$.each(data, function (key, item) {
			options.push({
				value: key,
				text: item.title
			});
			if (yotaPortlets.region.products.roaming && yotaPortlets.region.roaming == item.code) {
				self.current = key;
			}
		});
		return options;
	}

	onSelect(event, data) {
		const self = this;
		const value = data.value;
		if (!self.preventChange) {
			self.preventChange = true;
			$.each(self.select, function (key, select) {
				select.setValue(value);
			});
			self.price.set(self.data[value]);
			self.$el.addClass(self.options.classes.state.select);
			if (!self.overlay.isActive()) {
				self.$overlay.trigger('yota.overlay.open');
			}
			self.$overlay.data('params', [self.data[value].code.toLowerCase()]);
			self.$window.trigger('yota.router.check');
			self.onResize();
			setTimeout(function () {
				self.preventChange = false;
			}, 100);
		}
	}

	onClear() {
		$.each(this.select, function (key, select) {
			select.clear();
		});
		this.$el.removeClass(this.options.classes.state.select);
		this.$overlay.data('params', []);
		this.$window.trigger('yota.router.check');
		this.onResize();
	}

	onOpen() {
		this.info.close();
		this.onResize();
	}

	onClose() {
		this.onClear();
		this.info.close();
		this.onResize();
	}

	onResize() {
		const windowHeight = this.$window.outerHeight(true);
		const contentHeight = this.$content.outerHeight(true);
		this.$el.toggleClass(this.options.classes.state.scroll, windowHeight < contentHeight);
	}

	init() {
		const self = this;

		self.getDom();
		self.data = yotaPortlets.roaming;
		self.select = [];
		self.selectOptions = self.prepareOptions(self.data);

		self.$selects.each(function () {
			const select = new Select({el: $(this)}).render();
			select.setOptions(self.selectOptions);
			self.select.push(select);
		});

		self.overlay = new Overlay({
			el: self.$overlay,
			callback: {
				open: self.onOpen.bind(self),
				close: self.onClose.bind(self)
			}
		});

		self.$selects
			.on('yota.select.change', self.onSelect.bind(self))
			.on('yota.select.clean', self.onClear.bind(self));

		self.info = new Info({
			callback: {
				height: self.onResize.bind(self)
			}
		}).render();
		self.price = new Price().render();

		self.$window
			.on('resize.yota.roaming', self.onResize.bind(self))
			.trigger('resize.yota.roaming');

		if (self.current !== false) {
			self.onSelect(false, {value: self.current});
		}

		self.$overlay
			.on('yota.router.update', this.update.bind(this))
			.on('yota.router.activate', this.activate.bind(this))
			.trigger('yota.router.update')
			.trigger('yota.router.activate');

		return self;
	}

	find(code) {
		const self = this;
		const find = code;
		let search = false;
		$.each(self.selectOptions, function (key, item) {
			if (self.data[item.value].code.toLowerCase() == find) {
				search = item.value;
			}
		});
		return search;
	}

	update() {
		const params = this.$overlay.data('params') || [];
		if (params.length) {
			const value = this.find(params[0]);
			if (value !== false) {
				this.onSelect(false, {value: value});
			}
		}
	}

	activate() {
		const params = this.$overlay.data('params') || [];
		if (params.length) {
			const value = this.find(params[0]);
			if (value !== false) {
				this.onSelect(false, {value: value});
			}
		}
	}

	render() {
		const self = this;
		if (self.$el.length) {
			if (yotaPortlets.roaming) {
				if (yotaPortlets.roamingWait === true) {
					self.wait = setInterval(function () {
						if (yotaPortlets.roamingWait !== true) {
							self.init();
							clearInterval(self.wait);
						}
					}, 250);
				} else {
					self.init();
				}
			} else {
				console.error('The overlayRoaming portlet has no data, set data to "yotaPortlets.roaming"');
			}
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/roaming/roaming.js